export function excludeYourBetItems(items) {
    return items.filter(item => item.type !== "YourBet");
}
//# sourceMappingURL=excludeYourBetItems.js.map